import React from 'react';
import { Player } from '../types';

interface GameCompleteProps {
  players: Player[];
  onNewGame: () => void;
  onNewGameWithNewPlayers: () => void;
}

const GameComplete: React.FC<GameCompleteProps> = ({ players, onNewGame, onNewGameWithNewPlayers }) => {
  const sortedPlayers = [...players].sort((a, b) => b.totalScore - a.totalScore);

  return (
    <div className="bg-white rounded-none shadow-lg p-8 mb-7 border-none text-center">
      <h2 className="text-3xl font-bold mb-6">Game Complete!</h2>
      
      <div className="mb-8">
        <h3 className="text-xl font-bold mb-4">Final Scores</h3>
        <div className="space-y-3">
          {sortedPlayers.map((player, index) => (
            <div
              key={player.id}
              className={`p-4 rounded-md border-2 ${
                index === 0
                  ? 'bg-yellow-100 border-yellow-400 text-yellow-800'
                  : index === 1
                  ? 'bg-gray-100 border-gray-400 text-gray-800'
                  : index === 2
                  ? 'bg-orange-100 border-orange-400 text-orange-800'
                  : 'bg-white border-gray-200 text-gray-700'
              }`}
            >
              <div className="flex justify-between items-center">
                <span className="font-bold text-lg">
                  {index + 1}. {player.name}
                  {index === 0 && <span className="ml-2 text-2xl">🏆</span>}
                  {index === 1 && <span className="ml-2 text-2xl">🥈</span>}
                  {index === 2 && <span className="ml-2 text-2xl">🥉</span>}
                </span>
                <span className="text-xl font-bold">{player.totalScore} points</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="flex justify-center gap-4">
        <button onClick={onNewGame} className="btn">
          New Game (Same Players)
        </button>
        <button onClick={onNewGameWithNewPlayers} className="btn btn-secondary">
          New Game (New Players)
        </button>
      </div>
    </div>
  );
};

export default GameComplete; 